import React, { Component } from "react";
import Tick from "../images/tick.svg";
// import lang1 from '../images/defaultlanguage1.svg'
// import lang2 from '../images/defaultlanguage2.svg'
import Tooltip from "@mui/material/Tooltip";

const DefLang = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={props.fill}
    width="22px"
    height="15px"
    viewBox="0 0 790 550"
  >
    <g id="Layer_x0020_1">
      <path d="M440 480l240 0c10,0 20,-10 30,-10 0,-10 10,-20 10,-30l0 -270c0,-10 -10,-20 -10,-30 -10,0 -20,-10 -30,-10l-190 0 0 50 110 0c20,0 30,20 30,30 0,20 -10,30 -30,30l-10 0c0,20 -10,110 30,120 10,0 20,20 20,30 -10,20 -20,30 -40,20 -20,0 -40,-20 -50,-40l0 0 -60 0 0 10c0,30 -10,60 -30,80l0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 10 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 -10 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 -10 10 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0zm50 -240l0 80 40 0c0,-40 0,-70 0,-80l-40 0zm-240 -30c0,0 10,30 10,40 0,10 0,10 -10,10 -20,0 -20,0 -10,-10 0,-10 0,-40 10,-40zm10 80c0,10 10,60 20,60 0,10 10,20 20,20 20,0 30,-10 40,-30 0,-10 -10,-20 -10,-20 0,-10 0,-20 -10,-30 -10,-40 -30,-90 -40,-140 0,-10 -10,-10 -10,-20 -10,-10 -30,-10 -50,0 0,10 0,10 -10,20l-40 140c0,10 -10,20 -10,30 0,0 0,10 0,20 0,30 30,40 50,20 10,0 10,-10 10,-20 10,-10 10,-30 20,-50l20 0zm-150 130l220 0 10 0 40 0c10,0 20,-10 30,-10 0,-10 10,-20 10,-30l0 0 0 0 0 -270 0 -10c0,0 -10,-10 -10,-20 -10,0 -20,-10 -30,-10l-270 0c-10,0 -20,10 -30,10 0,10 -10,20 -10,30l0 270c0,10 10,20 10,30 10,0 20,10 30,10zm200 70l-200 0c-30,0 -60,-10 -80,-30 -20,-20 -30,-50 -30,-80l0 -270c0,-30 10,-60 30,-80 20,-20 50,-30 80,-30l270 0c30,0 60,10 80,30 10,10 20,20 20,30l200 0c30,0 60,10 80,30 20,20 30,50 30,80l0 270c0,30 -10,60 -30,80 -20,20 -50,30 -80,30l-270 0c-30,0 -50,-10 -70,-20l0 0c-20,-10 -20,-20 -30,-40z" />
    </g>
  </svg>
);

export default class LangItem extends Component {
  // constructor(props) {
  //     super(props);
  //     this.state =
  //     {
  //     };
  // }

  onclick() {
    this.props.onLangItemClick(this.props.id);
  }

  onDefaultClick() {
    this.props.onLangItemDefaultClick(this.props.id);
  }

  componentDidUpdate() {
    // ReactTooltip.rebuild();
  }

  render() {
    return (
      <div
        className="langItem"
        style={{
          backgroundColor: this.props.selected
            ? "var(--brown1)"
            : "var(--gray1)",
        }}
      >
        <div
          className="langItemTitle"
          style={{ color: this.props.selected ? "white" : "var(--gray3)" }}
        >
          {this.props.title}
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          onClick={this.onclick.bind(this)}
        />
        <div className="langItemActionContainer">
          {this.props.selected && (
            <Tooltip title="پیشفرض">
              <div
                className="langItemSub"
                style={{
                  color: this.props.default ? "white" : "rgba(255,255,255,0.5)",
                }}
                onClick={this.onDefaultClick.bind(this)}
                // data-tip="پیشفرض"
                // data-delay-show="350"
                // data-delay-hide="200"
              >
                <DefLang
                  fill={this.props.default ? "white" : "rgba(255,255,255,0.3)"}
                />
              </div>
            </Tooltip>
          )}
          {this.props.selected && (
            <img
              style={{ width: "15px", height: "15px", objectFit: "contain" }}
              alt=""
              src={Tick}
            />
          )}
        </div>
      </div>
    );
  }
}
